import './index.css'
import { useEffect, useState } from "react"
import { Box } from "@mui/material"
import { PADDING_BASE } from "../../assets/Styles"
import { TableSchema, columnId, rowDataPreprocesor, handleDoubleClickRow } from "./scheme"
import Copyright from "../common/Copyright"
import PageContainer from "../common/PageContainer"
import { Link, useNavigate } from "react-router-dom"
import { useProject } from "../../context/ProjectContext"
import { CompaniesFilterFormModel, DataCompany } from "../../models/company.model"
import { filterCompanies } from "../../services/company.service"
import DataTable from "../common/DataTable2"
import Breadcrumbs from "../common/Breadcrumbs"
import PrimaryMenuBar from "../CompanyActions"
import useUser from "../../hooks/useUser"


export default function CompaniesListing(props: any) {
  const setBlockScreen = props.setBlockScreen
  const { selectedProject } = useProject()
  const { userAdmin } = useUser()

  const navigate = useNavigate()

  const [companiesList, setCompaniesList] = useState<DataCompany[]>([]);
  const [loading, setLoading] = useState<boolean>(false)

  const defaultCompaniesFilter: CompaniesFilterFormModel = {
    id: '',
    name: '',
    from: '',
    to: '',
    project_id: selectedProject
  }

  const initComponent = () => {
    setBlockScreen(true)
    Promise.all([setTimeout(() => { }, 500)]).then(function (result: any[]) {
      setBlockScreen(false)
    }).catch((error) => {
      setBlockScreen(false)
    })
  };

  useEffect(initComponent, [])

  const setFilter = () => {
    setLoading(true)
    Promise.all([filterCompanies(selectedProject, {})]).then(function (results) {
      setCompaniesList(results[0])
      setLoading(false)
    }).catch((error) => {
      setLoading(false)
    });
  }

  useEffect(setFilter, [selectedProject])

  const handleDoubleClickCompany = (rowData: DataCompany) => {
    handleDoubleClickRow(selectedProject, rowData.code, navigate)
  }

  return (
    <>
      <PageContainer>
        <Box paddingBottom={PADDING_BASE}>
          <Breadcrumbs
            pathlist={[
              <Link className="breadcrumbs-nav__link" to="/tickets/listing">Home</Link>, 'Compañías'
            ]} />
        </Box>

        <div className="companies-listing-section">
          <PrimaryMenuBar
            handleOpenFilter={() => { }}
            setSearch={setFilter}
            resetPrimaryFilter={() => { }}
            defaultSearchForm={defaultCompaniesFilter}
            selectedProject={selectedProject}
            canEdit={userAdmin}
          />

          <DataTable
            columns={TableSchema}
            rows={companiesList.map((row) => rowDataPreprocesor(row, selectedProject))}
            onRowDoubleClick={handleDoubleClickCompany}
            loading={loading}
            columnId={columnId}
            onClickIdValue={handleDoubleClickCompany}
          />
        </div>

      </PageContainer>
      <Copyright marginBottom={'1rem'} />
    </>
  )
}
